import Link from "next/link";
import { usePathname } from "next/navigation";

const NotificationFooter = () => {
    const path = usePathname();

    return (
        <div className="fixed max-md:w-full bottom-0 flex flex-row max-sm:flex-col flex-wrap justify-center items-center w-full px-6 pb-6 text-center font-suisseBP text-[14px] bg-pureWhite">
            <h4 className="text-gray500 max-sm:block max-sm:w-full leading-5">Already have an active Inner Balance plan?</h4>
            <div className="flex flex-row items-center justify-center">
                <Link className="text-heroBlue inline-block underline mx-1 leading-5" href={"/sign-in/?returnTo=" + path}>Log in</Link>
                <span className="text-heroBlue leading-5">to get your exclusive discount</span>
            </div>
        </div>
    );
};

export default NotificationFooter;
